import { validateInputs } from 'shared/lib';
import { PasswordChangeErrors } from 'shared/consts/password-change.errors';

export const validatePasswordChangeForm = (
  password: string,
  confirmPassword: string
) => {
  if (!validateInputs.validatePassword(password)) {
    return PasswordChangeErrors.INCORRECT_PASSWORD;
  } else if (
    !validateInputs.validateConfirmPassword(password, confirmPassword)
  ) {
    return PasswordChangeErrors.PASSWORDS_NOT_MATCH;
  } else {
    return PasswordChangeErrors.NO_ERRORS;
  }
};
